export function escapeRegex(string) {
    return string.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
